export const LISTING_OUTLET_PARAMS = ["page", "date", "keyword", "sort", "is_verified", "countries", "premium", "trust_star"];
